import { styled } from '../../styled-components';

export const EditableTextContainer = styled.div.attrs({
  className: 'EditableTextContainer',
})`
  display: flex;
  align-items: center;
  width: 100%;
`;
